export const filenameToContentType = (filename: string, defaultType = ''): string => {
  const fileFormatSplit = filename.split('.');
  const fileFormat = fileFormatSplit[fileFormatSplit.length - 1].toLowerCase();

  switch (fileFormat || defaultType) {
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'pdf':
      return 'application/pdf';
    default:
      // Unknown file format so fall back to data stream
      return 'application/octet-stream';
  }
};
